import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO } from "../components/ui";
import { useI18n } from "../i18n";

export default function Legal({ type }) {
  const { t } = useI18n();
  const isPrivacy = type === "privacy";
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-100 h-16 flex items-center px-5 max-w-4xl mx-auto">
        <Link to="/" className="flex items-center gap-2"><img src={LOGO} className="h-9 w-9 object-contain" alt="" />
          <span className="font-head font-extrabold text-navy text-lg">Spina<span className="text-teal">Go</span></span></Link>
        <Link to="/" className="ms-auto text-sm text-slate-500 flex items-center gap-1"><ArrowLeft size={15} className="rtl:rotate-180" /> Accueil</Link>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12 prose">
        <h1 className="font-head font-bold text-navy text-3xl mb-4">{isPrivacy ? t("privacy") : t("terms")}</h1>
        <p className="text-sm text-warn bg-orange-50 border border-orange-100 rounded-lg px-4 py-3 mb-6">
          Modèle configurable. {t("footer_legal")}
        </p>
        <div className="space-y-4 text-slate-600 leading-relaxed text-sm">
          {isPrivacy ? (
            <>
              <p>SpinaGo, édité par SpinaTech, traite des renseignements de santé dans le cadre du suivi des programmes thérapeutiques. Chaque cabinet est responsable des données de ses patients (isolation multicabinet stricte).</p>
              <p><b>Données collectées :</b> identité, coordonnées, contexte clinique saisi par le professionnel, activités d'exercices, niveaux de douleur et de difficulté, commentaires, journaux d'accès.</p>
              <p><b>Consentements :</b> le patient peut consulter et retirer certains consentements lorsque cela est permis. Les versions et dates sont conservées.</p>
              <p><b>Conservation :</b> durée configurable par cabinet. Les données peuvent être exportées, corrigées ou archivées selon les permissions.</p>
              <p>SpinaGo ne déclare pas automatiquement la conformité à une réglementation particulière (RGPD, HIPAA, Loi 25, réglementation algérienne). Une validation juridique est requise avant toute utilisation réelle.</p>
            </>
          ) : (
            <>
              <p>En utilisant SpinaGo, vous acceptez de fournir des informations exactes et de respecter les consignes de votre professionnel de santé.</p>
              <p>SpinaGo est un outil de prescription, d'explication et de suivi d'exercices. Il ne pose aucun diagnostic et ne recommande aucun paramètre thérapeutique de manière automatique. Toutes les décisions cliniques sont saisies et approuvées par le professionnel.</p>
              <p>La messagerie ne doit pas être utilisée en cas d'urgence médicale.</p>
              <p>SpinaGo n'est pas affilié à Physitrack. Les marques citées appartiennent à leurs propriétaires respectifs.</p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
